import { CSSObject, Theme } from '@mui/material'

import { inputWidth } from 'providers/material-ui/theme/constants'

export const styles = (theme: Theme): CSSObject => ({
  backgroundColor: theme.palette.white.main,
  width: inputWidth['lg'],
  zIndex: theme.zIndex.tableFilter,
})
